import React from 'react';


function License() {

    return (
        <div className="license">
            <h2>Copyright (c) 2023 Frinken Milan</h2>
            <br/>
            <a className="link" href={"https://www.gnu.org/licenses/gpl-3.0-standalone.html"}>COPYING</a>
            <br/>
            <a className="link"
               href={"https://github.com/MFrikken/howtoplaychessofflinefast"}>GitHub</a>
            <br/>
            <br/>
            <div className="license-text">
                How To Play Chess Offline (fast) is free software: you can redistribute it and/or modify
                it under the terms of the GNU General Public License as published by
                the Free Software Foundation, either version 3 of the License, or (at your option) any later version.
                This program is distributed in the hope that it will be useful,
                but WITHOUT ANY WARRANTY; without even the implied warranty of
                MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
                GNU General Public License for more details.
                You should have received a copy of the GNU General Public License
                along with this program. If not, see <a href={"https://www.gnu.org/licenses/"}>www.gnu.org/licenses/</a>.
            </div>
            <br/>
            <br/>
            <br/>

        </div>

    );
}

export default License;